export default __webpack_public_path__ + "static/media/search-is-nothing-found.4b9e7ff3.svg";